import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Card, Typography } from "antd";
import { FC, useEffect, useState } from "react";

const { Title, Text } = Typography;
const { TextArea } = Input;

interface Props {
  enhancementProcedure: any;
  form: any;
  isProcedureSubmitted?: boolean;
}

const NewUnlistedFormEchs: FC<Props> = ({ enhancementProcedure, form, isProcedureSubmitted }) => {
  const [totalProcedureAmount, setTotalProcedureAmount] = useState(0);

  const items = Form.useWatch("items", form);

  useEffect(() => {
    if (enhancementProcedure?.length) {
      form.setFieldsValue({ items: enhancementProcedure });
    }
  }, [enhancementProcedure]);

  useEffect(() => {
    const calculateTotal = (data: any[]) => {
      return data?.reduce((sum: number, procedure: any) => {
        const amount = parseFloat(procedure?.cost || "0");
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
    };

    let total = 0;

    if (Array.isArray(items) && items.length > 0) {
      total += calculateTotal(items);
    }

    setTotalProcedureAmount(total);
  }, [form, items]);

  return (
    <Card
      title="Procedure Entries"
      style={{ borderRadius: 12 }}
      bodyStyle={{ padding: "0px 16px" }}
    >
      <div
        style={{ padding: "2px 14px", overflow: "auto" }}
        className="enhancement-procedures-modal"
      >
        <div className="procedureList">
          <Form
            form={form}
            labelAlign="left"
            labelWrap
            labelCol={{
              xs: { span: 24 },
              sm: { span: 12 },
              md: { span: 8 },
              lg: { span: 6 },
            }}
            wrapperCol={{
              xs: { span: 24 },
              sm: { span: 12 },
              md: { span: 16 },
              lg: { span: 18 },
            }}
            style={{ width: "100%" }}
          >
            <Form.List name="items" initialValue={[{ status: true }]}>
              {(fields, { add, remove }) => (
                <>
                  <div
                    style={{
                      height: "52vh",
                      overflowY: "auto",
                      paddingRight: "8px",
                    }}
                  >
                    <div
                      style={{
                        border:
                          Array.isArray(fields) && fields?.length > 0
                            ? "1px solid #D9D9D9"
                            : "none",
                        borderRadius: "16px",
                        padding: "10px 20px",
                        marginBottom: "0.8rem",
                        width: "100%",
                      }}
                    >
                      {Array.isArray(fields) &&
                        fields?.map((field, index) => {
                          return (
                            <Row
                              key={field.key}
                              gutter={[16, 16]}
                              align="top"
                              style={{
                                border: "1px solid #C4C4C4",
                                padding: "10px 20px",
                                borderRadius: "16px",
                                marginBottom: "0.8rem",
                              }}
                            >
                              <Col span={8}>
                                <Form.Item
                                  {...field}
                                  label="Procedure"
                                  name={[
                                    field.name,
                                    "procedureName",
                                  ]}
                                  rules={[
                                    { required: true, message: "Required" },
                                  ]}
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Input
                                    style={{ borderRadius: "5px" }}
                                    placeholder="Enter Procedure"
                                    disabled={isProcedureSubmitted}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={8}>
                                <Form.Item
                                  {...field}
                                  label="Diagnosis/Reason"
                                  name={[field.name, "diagnosisReason"]}
                                  rules={[
                                    { required: true, message: "Required" },
                                  ]}
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Input
                                    style={{ borderRadius: "5px" }}
                                    placeholder="Enter Diagnosis/Reason"
                                    disabled={isProcedureSubmitted}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={7}>
                                <Form.Item
                                  {...field}
                                  label="Cost"
                                  name={[
                                    field.name,
                                    "cost",
                                  ]}
                                  rules={[
                                    { required: true, message: "Required" },
                                    {
                                      pattern: /^[0-9]+$/,
                                      message: "contain only  numeric values!",
                                    },
                                  ]}
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Input
                                    style={{ borderRadius: "5px" }}
                                    placeholder="Enter Cost"
                                    disabled={isProcedureSubmitted}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={1}>
                                {fields.length > 0 && !isProcedureSubmitted && (
                                  <Button
                                    type="text"
                                    style={{ color: "red", padding: "0" }}
                                    icon={<MinusCircleOutlined />}
                                    onClick={() => remove(field.name)}
                                  />
                                )}
                              </Col>
                            </Row>
                          );
                        })}
                    </div>
                  </div>
                  
                  {
                    isProcedureSubmitted ? <></> : <div style={{ marginBottom: "0.4rem", marginTop: "2rem" }}>
                    <Button
                      type="dashed"
                      onClick={() => add({ status: true })}
                      style={{
                        background: "#00549E",
                        color: "white",
                        boxShadow: "0px 2px 8px 0px #00000040",
                        border: "1px solid #C4C4C4",
                      }}
                    >
                      Add Procedure
                    </Button>
                  </div>
                  }
                </>
              )}
            </Form.List>
            <div style={{ width: "100%", }}>
              <h4 style={{ display: "flex", justifyContent: "end" }}>
                Total Amount: ₹ {totalProcedureAmount}/-
              </h4>
            </div>

            <Row gutter={[16, 16]} align="top" style={{ marginLeft: 10 }}>
              <Col span={24}>
                <Form.Item
                  label="Remarks"
                  name="remarks"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                  rules={[
                    {
                      required: true,
                      message: "Enter Remarks",
                    },
                  ]}
                >
                  <Input
                    style={{ borderRadius: "9px" }}
                    disabled={isProcedureSubmitted}
                    placeholder="Enter Remarks"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </Card>
  );
};

export default NewUnlistedFormEchs;
